export default {
    path: '/dashboard/help-centre',
    meta: {
        menuLabel: 'Help Centre'
    },
    components: {
        default: () => import('../../views/memberDashboard/dashboard/index.vue'),
        header: () => import('../../views/memberDashboard/header/index.vue'),
        footer: () => import('../../views/public/footer/index.vue'),
    },
    children: [
        {
            path: '',
            redirect: 'getting-started-guide'
        },
        {
            path: 'getting-started-guide',
            name: 'memberDashboard.helpCentre.startedGuide',
            meta: {
                menuLabel: 'Learner Hints & Tips',
                middleware: {
                    mustBeAuthenticated: true
                }
            },

            component: () => import('../../views/memberDashboard/helpCentre/GettingStartedGuide.vue'),
        }
        // {
        //     path: 'industry-information',
        //     name: 'memberDashboard.helpCentre.industryInformation',
        //     meta: {
        //         menuLabel: 'Industry Information',
        //         middleware: {
        //             mustBeAuthenticated: true,
        //             mustHasRoles: ['member']
        //         }
        //     },

        //     component: () => import('../../views/memberDashboard/helpCentre/IndustryInformation.vue'),
        // },
    ]
}